import { Avatar, AvatarFallback, AvatarImage } from '@/app/shared/components';
/////////////////////////////////////////////////////////////
import { useCustomSelector } from '@/core/redux/hooks';
import { useTonAddress } from '@tonconnect/ui-react';

export const UserData: React.FC = () => {
	/*********************
	// #region Hooks
	**********************/
	const userFriendlyAddress = useTonAddress();

	/*********************
	// #region Redux
	**********************/
	const { username, firstName } = useCustomSelector(
		(state) => state.user.data
	);
	const { levelName } = useCustomSelector((state) => state.counter);

	/*********************
	// #region Template
	**********************/
	return (
		<div className="flex flex-col items-center gap-1">
			<Avatar className="h-24 w-24">
				{process.env.VITE_PROFILE_IMAGE && (
					<AvatarImage
						className="drop-shadow-2xl"
						src={process.env.VITE_PROFILE_IMAGE}
					/>
				)}
				{username && (
					<AvatarFallback>
						{username.slice(0, 2).toUpperCase()}
					</AvatarFallback>
				)}
			</Avatar>

			<div className="text-center">
				{username && (
					<div className="font-extralight text-sm">{firstName}</div>
				)}
				<div className="font-extralight text-sm">
					{userFriendlyAddress &&
						`${userFriendlyAddress.slice(
							0,
							10
						)}...${userFriendlyAddress.slice(-8)}`}
				</div>
				<div className="font-bold text-base">{levelName}</div>
			</div>
		</div>
	);
};
